import { NgModule } from '@angular/core';
import { TopbarComponent } from './components/topbar/topbar.component';
import { DashboardLayoutComponent } from './components/dashboard-layout/dashboard-layout.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [TopbarComponent, DashboardLayoutComponent],
  imports: [SharedModule, RouterModule],
  exports: [DashboardLayoutComponent],
})
export class UiModule {}
